export const MAX_PROPOSALS_IN_STORY = 20;
